import { c as _c } from "react/compiler-runtime";
import { BaseApiInterface, getData } from 'modules/digital-product/resources/hooks/use-digital-resources';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { LIGHT_COURSES_LIST_ALL_API } from '../light-course-api';
export const useLightCoursesListAll = () => {
  const $ = _c(8);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== user) {
    t1 = () => {
      if (!user) {
        return null;
      }
      return [`${LIGHT_COURSES_LIST_ALL_API}?active=true`, RequestModuleEnum.MembershipLightCourse];
    };
    $[1] = user;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data,
    mutate
  } = useControlledSwr(t1, fetcher);
  let t2;
  if ($[3] !== data) {
    t2 = getData(data);
    $[3] = data;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== mutate || $[6] !== t2) {
    t3 = {
      coursesData: t2,
      mutate
    };
    $[5] = mutate;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};